export default {"src":"/_next/static/media/applogo.5f363861.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};